<div class="form-image-local">
  {{title}}
  <img [src]="imgPreview" class="local-image" />
  <div class="form-group" style="max-width: 150px; justify-content: center; gap: 20px;">
    <div class="form-control" style="min-width:0px;">
      <div
        class="table-action" 
        style="cursor:pointer;"
        (click)="photoCam()"
        pTooltip="Tirar Foto"
      >
        <i class="pi pi-camera"></i>
      </div>
    </div>
    <div class="form-control" style="min-width:0px;" pTooltip="Carregar Imagem">
      <p-fileUpload
      style="padding-left: 3px;"
        name="attachment"
        mode="basic"
        auto="true"
        maxFileSize="100000000"
        chooseLabel=" "
        accept=".png,.jpg,.jpeg,.pdf"
        #upload
        [auto]="true"
        customUpload="true"
        chooseIcon="pi pi-cloud-upload"
        class="p-fileupload-mini"
        (uploadHandler)="setFile($event.files)"
      >
      </p-fileUpload>
    </div>
  </div>
</div>